/**
 * Dependency-free read of "is the session still alive?", for modules that sit BELOW the
 * Redux store in the import graph and therefore cannot import it.
 *
 * `queryClient`'s retry predicate needs `auth.loggedIn` to tell recovery from a
 * stampede, but a dozen reducers and thunks import its `client` — so a
 * `queryClient -> app/store` edge closes the cycle
 * `app/store -> ChartsReducer -> queryClient -> app/store`. `combineReducers` then
 * touches a reducer whose module body has not finished evaluating and the whole app dies
 * at import time with "Cannot access 'initialState' before initialization". Registering
 * the getter from `app/store` inverts that edge; this module imports nothing, so it can
 * never participate in a cycle.
 *
 * Defaults to `true` — before registration, behave exactly as for a live session.
 */
let readIsSessionLive: () => boolean = () => true

export function setSessionLivenessSource(read: () => boolean): void {
  readIsSessionLive = read
}

export function isSessionLive(): boolean {
  return readIsSessionLive()
}
